export const closings = {
	title: "Cierre por vendor",
	download: "Descargar hoja de cálculo",
	choosePeriod: "Elija período para exportar hoja de cálculo",
	sheet: {
		title: "Cierre de vendors",
		filename: "cierre-de-vendors",
		columns: {
			vendorName: "vendor",
			vendorValueToReceive: "Valor a recibir",
			otherProductsFeeValue: "Tasa variable sobre productos especiales",
			generalFeeValue: "Tasa variable general",
			eventDate: "Fecha del evento",
			payDate: "Fecha de transferencia",
			generalPercentageFee: "Tasa variable sobre facturación",
			fixedFee: "Tasa de alquiler fija",
			totalSoldValue: "Facturación total",
		},
	},
	calendar: {
		totalSoldValue: "Valor total",
		toReceive: "A recibir",
	},
	modal: {
		details: "Detalles del día",
		vendorName: "Vendor",
		vendorValueToReceive: "Valor a recibir",
		otherProductsFeeValue: "Tasa variable sobre productos especiales",
		generalFeeValue: "Tasa variable general",
		eventDate: "Fecha del evento",
		payDate: "Fecha de transferencia",
		generalPercentageFee: "Tasa variable sobre facturación",
		fixedFee: "Tasa de alquiler fijo",
		totalSoldValue: "Facturación total",
	},
};
